import { extractRouteParamValues } from '@Core/utils/routeParams';
import { buildEditorUrl } from '@Pages/utils/routeParamsUrlUtils';

export function buildEditorHref(
  pageId: string,
  pageRouteSettings?: Record<string, Diagonal.Pages.Data.PageRouteSettingsData> | null
): string {
  const routeSettings = pageRouteSettings?.[pageId];

  if (!routeSettings?.route || !routeSettings.params?.length) {
    return buildEditorUrl(pageId, {});
  }

  return buildEditorUrl(
    pageId,
    extractRouteParamValues(routeSettings.route, window.location.pathname) ?? {}
  );
}
